"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthActionBase = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var core_1 = require("@dp-instant/core");
var utils_1 = require("@dp-instant/utils");
var inversify_1 = require("inversify");
var AppModel_1 = require("../model/AppModel");
var auth_1 = require("firebase/auth");
var AuthActionBase = (function (_super) {
    tslib_1.__extends(AuthActionBase, _super);
    function AuthActionBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthActionBase.prototype.execute = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, id, name, photo, signature, response;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.getPlayerInfo()];
                    case 1:
                        _a = _b.sent(), id = _a.id, name = _a.name, photo = _a.photo, signature = _a.signature;
                        this.model.signature = signature;
                        return [4, this.model.post("auth", { user_id: id, signature: signature }, false)];
                    case 2:
                        response = _b.sent();
                        if (!response) return [3, 4];
                        if (!!response.token) return [3, 4];
                        return [4, this.model.post("auth", { user_id: id, user_photo: photo, user_name: name, signature: signature }, false)];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4: return [4, this.proceedToken(response === null || response === void 0 ? void 0 : response.token)];
                    case 5:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    AuthActionBase.prototype.proceedToken = function (token) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var credentials, auth, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!token) return [3, 5];
                        credentials = void 0;
                        auth = void 0;
                        try {
                            auth = (0, auth_1.getAuth)(this.model.firebaseApp);
                        }
                        catch (e) {
                            return [2, utils_1.log.warn("getAuth failed with error", e)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, (0, auth_1.signInWithCustomToken)(auth, token)];
                    case 2:
                        credentials = _a.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [2, utils_1.log.warn("signInWithCustomToken failed with error", e_1)];
                    case 4:
                        utils_1.log.info("#auth success", credentials);
                        return [3, 6];
                    case 5:
                        utils_1.log.warn("#auth missed token");
                        _a.label = 6;
                    case 6: return [2];
                }
            });
        });
    };
    AuthActionBase.prototype.loadProfileImage = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var imageData, data, dataBlob_1, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!url) return [3, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4, fetch(url)];
                    case 2:
                        data = _a.sent();
                        return [4, data.blob()];
                    case 3:
                        dataBlob_1 = _a.sent();
                        return [4, new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.onloadend = function () { return resolve(reader.result); };
                                reader.onerror = reject;
                                reader.readAsDataURL(dataBlob_1);
                            })];
                    case 4:
                        imageData = _a.sent();
                        return [3, 6];
                    case 5:
                        e_2 = _a.sent();
                        utils_1.log.warn("Failed to load profile image");
                        return [3, 6];
                    case 6: return [2, imageData];
                }
            });
        });
    };
    AuthActionBase.prototype.auth = function (user_id, signature) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2];
        }); });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesApp.model),
        tslib_1.__metadata("design:type", AppModel_1.AppModel)
    ], AuthActionBase.prototype, "model", void 0);
    AuthActionBase = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], AuthActionBase);
    return AuthActionBase;
}(core_1.Action));
exports.AuthActionBase = AuthActionBase;
//# sourceMappingURL=AuthActionBase.js.map